import { lockControlFromClosing, unlockControlFromClosing } from '../features/base/control-strip/functions';
import { getRemoteParticipantMainVideoTrack } from '../features/base/tracks/functions';
import {room,Video,CONV_STORAGE,socket,hideSideMenu, muteParticipants, muteMic, unMuteMic, volumeManager, kinoParticipants, permissions} from './roomnew';
export default class Announcement {
    constructor() {
        this.btnLabel='';
        this.optionsBtn=null;
        this.toolBoxComponent=null;
        this.statusLabel='';
        this.announceBtn=null;
        this.pressHoldDuration=20;
        this.pressReadyDuration=50;
        this.holdCounter=0;
        this.timerID=0;
        this.announcers=[];
        this.announcersVolume={};
        this.originalVolumes={};
        this.announcing=false;
        this.closeBtn=null;
        this.muteOnStopAnnouncing = false;
        this.quickAnnounce = false;
        this.accouncementZone = $('#announcement-zone');
        this.htmlIcon=`<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" fill="#032836" xml:space="preserve"><path d="M497,241h-45c-8.284,0-15,6.716-15,15s6.716,15,15,15h45c8.284,0,15-6.716,15-15S505.284,241,497,241z"/><path d="M477.607,335.394l-30-30c-5.857-5.857-15.355-5.857-21.213,0c-5.859,5.857-5.859,15.355,0,21.213l30,30c5.857,5.858,15.356,5.858,21.213,0C483.465,350.749,483.465,341.252,477.607,335.394z"/><path d="M477.606,155.394c-5.857-5.857-15.355-5.857-21.213,0l-30,30c-5.858,5.858-5.858,15.355,0,21.213c5.858,5.858,15.356,5.857,21.213,0l30-30C483.464,170.749,483.464,161.252,477.606,155.394z"/><path d="M347,61c-22.531,0-41.245,16.645-44.497,38.284l-13.683,13.683C265.005,136.782,229.933,151,195,151h-90c-19.555,0-36.228,12.541-42.42,30H60c-33.084,0-60,26.916-60,60s26.916,60,60,60h2.58c4.527,12.764,14.656,22.893,27.42,27.42         V406c0,24.813,20.188,45,45.001,45C159.813,451,180,430.813,180,406v-75h15c34.932,0,70.004,14.218,93.82,38.033l13.683,13.683C305.755,404.354,324.47,421,347.001,421C371.813,421,392,400.813,392,376V106C392,81.187,371.813,61,347,61z M60,271         c-16.542,0-30-13.458-30-30s13.458-30,30-30V271z M150,406c0,8.271-6.729,15-15,15s-15-6.729-15-15v-75h30V406z M180,301h-75c-8.271,0-15-6.729-15-15v-90c0-8.271,6.729-15,15-15h75V301z M302,340.346c-25.341-21.932-57.922-35.559-92.1-38.666   l0.001-121.361c34.177-3.106,66.758-16.733,92.099-38.666V340.346z M362,376c0,8.271-6.729,15-14.999,15H347c-8.271,0-15-6.729-15-15V106c0-8.271,6.729-15,15.001-15c8.27,0,14.999,6.729,14.999,15V376z"/></svg>`;
        this.announcementIcon=`<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="9.5" fill="white" fill-opacity="0.8" stroke="#F89F37"/>
        <path d="M17.5312 9.53125H16.125C15.8661 9.53125 15.6562 9.74112 15.6562 10C15.6562 10.2589 15.8661 10.4688 16.125 10.4688H17.5312C17.7901 10.4688 18 10.2589 18 10C18 9.74112 17.7901 9.53125 17.5312 9.53125Z" fill="#F89F37"/>
        <path d="M16.9252 12.481L15.9877 11.5435C15.8047 11.3605 15.5079 11.3605 15.3248 11.5435C15.1417 11.7266 15.1417 12.0234 15.3248 12.2064L16.2623 13.1439C16.4454 13.327 16.7422 13.327 16.9252 13.1439C17.1083 12.9609 17.1083 12.6641 16.9252 12.481Z" fill="#F89F37"/>
        <path d="M16.9252 6.85602C16.7422 6.67299 16.4454 6.67299 16.2623 6.85602L15.3248 7.79352C15.1417 7.97659 15.1417 8.27337 15.3248 8.45643C15.5079 8.63949 15.8047 8.63946 15.9877 8.45643L16.9252 7.51893C17.1083 7.33587 17.1083 7.03909 16.9252 6.85602Z" fill="#F89F37"/>
        <path d="M12.8438 3.90625C12.1397 3.90625 11.5548 4.42641 11.4532 5.10262L11.0256 5.53022C10.2814 6.27444 9.18541 6.71875 8.09375 6.71875H5.28125C4.67016 6.71875 4.14913 7.11066 3.95563 7.65625H3.875C2.84113 7.65625 2 8.49738 2 9.53125C2 10.5651 2.84113 11.4062 3.875 11.4062H3.95563C4.09709 11.8051 4.41363 12.1217 4.8125 12.2631V14.6875C4.8125 15.4629 5.44338 16.0938 6.21878 16.0938C6.99416 16.0938 7.625 15.4629 7.625 14.6875V12.3438H8.09375C9.18537 12.3438 10.2814 12.7881 11.0256 13.5323L11.4532 13.9599C11.5548 14.6361 12.1397 15.1562 12.8438 15.1562C13.6192 15.1562 14.25 14.5254 14.25 13.75V5.3125C14.25 4.53709 13.6192 3.90625 12.8438 3.90625ZM3.875 10.4688C3.35806 10.4688 2.9375 10.0482 2.9375 9.53125C2.9375 9.01431 3.35806 8.59375 3.875 8.59375V10.4688ZM6.6875 14.6875C6.6875 14.946 6.47722 15.1562 6.21875 15.1562C5.96028 15.1562 5.75 14.946 5.75 14.6875V12.3438H6.6875V14.6875ZM7.625 11.4062H5.28125C5.02278 11.4062 4.8125 11.196 4.8125 10.9375V8.125C4.8125 7.86653 5.02278 7.65625 5.28125 7.65625H7.625V11.4062ZM11.4375 12.6358C10.6456 11.9504 9.62744 11.5246 8.55937 11.4275L8.55941 7.63497C9.62744 7.53791 10.6456 7.11206 11.4375 6.42666V12.6358ZM13.3125 13.75C13.3125 14.0085 13.1022 14.2188 12.8438 14.2188H12.8438C12.5853 14.2188 12.375 14.0085 12.375 13.75V5.3125C12.375 5.05403 12.5853 4.84375 12.8438 4.84375C13.1022 4.84375 13.3125 5.05403 13.3125 5.3125V13.75Z" fill="#032836"/>
        </svg>
        `
        this.announceIconFilled = `<svg width="512" height="512" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M497 241H452C443.716 241 437 247.716 437 256C437 264.284 443.716 271 452 271H497C505.284 271 512 264.284 512 256C512 247.716 505.284 241 497 241Z" fill="#e0e4e5"/><path d="M477.607 335.394L447.607 305.394C441.75 299.537 432.252 299.537 426.394 305.394C420.535 311.251 420.535 320.749 426.394 326.607L456.394 356.607C462.251 362.465 471.75 362.465 477.607 356.607C483.465 350.749 483.465 341.252 477.607 335.394Z" fill="#e0e4e5"/><path d="M477.606 155.394C471.749 149.537 462.251 149.537 456.393 155.394L426.393 185.394C420.535 191.252 420.535 200.749 426.393 206.607C432.251 212.465 441.749 212.464 447.606 206.607L477.606 176.607C483.464 170.749 483.464 161.252 477.606 155.394Z" fill="#e0e4e5"/><path d="M347 61C324.469 61 305.755 77.645 302.503 99.284L288.82 112.967C265.005 136.782 229.933 151 195 151H105C85.445 151 68.772 163.541 62.58 181H60C26.916 181 0 207.916 0 241C0 274.084 26.916 301 60 301H62.58C67.107 313.764 77.236 323.893 90 328.42V406C90 430.813 110.188 451 135.001 451C159.813 451 180 430.813 180 406V331H195C229.932 331 265.004 345.218 288.82 369.033L302.503 382.716C305.755 404.354 324.47 421 347.001 421C371.813 421 392 400.813 392 376V106C392 81.187 371.813 61 347 61Z" fill="#e0e4e5"/></svg>`;
        this.events();
    };

    events(){
        let s = this;
        s.accouncementZone.on("mouseup mouseleave", s.pressStop.bind(this,s));
    }

    addOptionButton(){
        var s=this;
        if(s.optionsBtn!==null){return}
        const hasAccess=permissions.hasAnnouncer();
        if(!hasAccess && !permissions.isWorkspace){
            return
        }
        s.btnLabel=`Announcer`;
        s.optionIcon = $('<div/>', {
            class: "option-icon",
            id: "announcementsIcon",
            html: s.htmlIcon,
        });
        s.optionName = $('<div/>', {
            class: "option-name",
            id: "option-name-announce",
            html: s.btnLabel,
        });
        s.optionAction = $('<div/>', {
            class: "option-action",
            id: "option-action-announce",
            html: '',
        });
        s.optionDescription = $('<div/>', {
            class: "option-description",
            html: [ s.optionName, s.optionAction],
        });
        s.optionsBtn = $('<div/>', {
            class: `option ${!hasAccess ? 'feature-disabled' : ''}`,
            id: 'startAnnouncementBtn',
            html: [s.optionIcon, s.optionDescription],
        }).on('click',function(){
            if(!hasAccess){return}
            if(s.toolBoxComponent===null){
                s.showToolBoxComponents();
            }else{
                s.hideToolBoxComponent();
            }
            hideSideMenu();
        });
        if(!hasAccess){
            s.optionsBtn.attr('data-toggle','tooltip')
            s.optionsBtn.attr('data-placement','top')
            s.optionsBtn.attr('data-original-title','This feature is disabled in this workspace.')
        }
        $("#startAnnouncementBtn").remove();
        $("#option-list").append(s.optionsBtn);
    };

    removeOptionButton(){
        var s=this;
        if(s.optionsBtn===null){return}
        s.optionsBtn.remove();
        s.optionsBtn=null;
        $("#startAnnouncementBtn").remove();
        s.hideToolBoxComponent();
        if(s.announcing){
            s.pressStop(s);
        }
    };


    showToolBoxComponents(){
        var s=this;
        if(s.toolBoxComponent!==null){return}
        s.announceBtn=$('<button/>',{
            class:'btn announce-btn',
            id: 'announce-btn',
            html: s.announcementIcon
        }).on('mousedown', function(e){
            if(e.which == 1){
                s.pressStart(s)
            }
            s.pressHoldDuration = 20;
            s.pressReadyDuration = 50;
            // s.quickAnnounce = false;
        })
            .on("mouseup", s.pressStop.bind(this,s))
            //.on("mouseup", s.pressStop.bind(this,s))
            .on("touchstart", s.pressStart.bind(this,s))
            .on("touchend", s.pressStop.bind(this,s));

        s.statusLabel=$('<div/>',{
            class:`announce-status`,
            id:'announce-label-text',
            html:'Press and hold to announce',
        });
        s.closeBtn=$("<span/>",{
            class:'close-btn',
            html:`<i class="icofont-close icofont-1x"></i>`,
        }).on('click',s.hideToolBoxComponent.bind(s));

        s.removeAnnounceBtn=$("<span/>", {
            class:'remove-announce-btn',
            html:`<svg class="remove-option-icon" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 45.334 45.334" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M43.576 35.092 31.152 22.668l12.424-12.424a6 6 0 0 0-8.485-8.485L22.666 14.183 10.242 1.758a6 6 0 0 0-8.485 8.485l12.425 12.424L1.757 35.091a6 6 0 1 0 8.486 8.485l12.423-12.423 12.425 12.424c1.173 1.171 2.707 1.757 4.243 1.757s3.071-.586 4.243-1.757a6 6 0 0 0-.001-8.485z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path></g></svg>` 
        }).on("click", function(){
            s.hideToolBoxComponent();    
        })

        s.toolBoxComponent=$('<div/>',{
            class:`toolbox-announcement border-class ${$(".strip-options-content").children().length < 4 && "border-right-white"}`,
            id:'toolbox-announcement',
            html:[s.announceBtn,s.statusLabel,s.removeAnnounceBtn/*s.announceSafeZone*/]
        }).on('mouseenter',function(){
            try {
                if(CONV_STORAGE.myConversation
                    && CONV_STORAGE.conversations[CONV_STORAGE.myConversation]
                    && CONV_STORAGE.conversations[CONV_STORAGE.myConversation].is_private
                    && CONV_STORAGE.private && s.toolBoxComponent){
                        s.toolBoxComponent.attr('title', 'Announcing from a private space, everyone will see and hear you');
                        s.toolBoxComponent.attr('data-original-title', 'Announcing from a private space, everyone will see and hear you');
                        s.toolBoxComponent.tooltip('show');
                    }else{
                        s.toolBoxComponent.attr('title', '');
                        s.toolBoxComponent.attr('data-original-title', '');
                        s.toolBoxComponent.tooltip('destroy');
                    }
            } catch (error) { console.error("[Kino Error] [announcement]", error); }

        });
        $(".strip-options-content").prepend(s.toolBoxComponent);
    };

    hideToolBoxComponent(){
        var s=this;
        if(s.toolBoxComponent!==null){
            s.toolBoxComponent.remove();
        }

        $("#toolbox-announcement").remove();
        s.toolBoxComponent=null;
        s.announceBtn=null;
        s.closeBtn=null;
        s.statusLabel=null;
    };


    pressStart(s){
        requestAnimationFrame(s.pressingTimer.bind(s));
        $("#announce-label-text").html('Keep pressing...');
        console.log(s);
        //e.preventDefault();
        console.log("pressing");
    };
    pressStop(s){
        // if(s.quickAnnounce){
            //     s.hideToolBoxComponent();
            // }
        cancelAnimationFrame(s.timerID);
        if(!s.announcing){
            $("#announce-label-text").html("Press and hold to announce");
            $("#toolbox-announcement").removeClass("ready pulse");
            return;
        }
        s.announcing=false;
        s.holdCounter=0;
        s.stopAnnouncing();
        $("#announce-label-text").html("Press and hold to announce");
        $("#toolbox-announcement").removeClass("ready pulse");
        console.log("Stopped pressing");
        s.quickAnnounce = false
    };
    pressingTimer(){
        var s=this;
        console.log('Timer tick');
        $('#announce-btn').addClass("loading");
        if(s.holdCounter <= s.pressReadyDuration){
            if(s.holdCounter==s.pressHoldDuration){
                console.log('Sending start announcement message');
                s.sendStartAnnouncementMsg();
                s.announcing=true;
            }
            s.timerID=requestAnimationFrame(s.pressingTimer.bind(this));
            s.holdCounter++;

        }else{
            console.log("Press threshold reached!");
            s.startAnnouncing();
            if(s.quickAnnounce){
                setTimeout(() => {
                    Video.localVideo.viewContainer.addClass('video-hover');
                    Video.localVideo.viewContainer.find('.announce-icon svg').addClass('announcing')
                }, 100);
            }
        }
    };

    startAnnouncing(){
        var s=this;
        $("#toolbox-announcement").addClass("ready pulse");
        $("#announce-label-text").html("Announcing...");
        $("#announcement-zone").css( 'display' ,'block');
        $('#announce-btn').removeClass("loading");
        s.announcing=true;
        //unmute mic if muted
        try{
            s.muteOnStopAnnouncing = room.getLocalAudioTrack().isMuted();
            if(s.muteOnStopAnnouncing){
                unMuteMic();
            }

        }catch(e){
            console.log("Can not unmute audio");
        }

        lockControlFromClosing()
    };

    stopAnnouncing(){
        var s=this;
        try {
            if(CONV_STORAGE.myConversation
                && CONV_STORAGE.conversations[CONV_STORAGE.myConversation]
                && CONV_STORAGE.conversations[CONV_STORAGE.myConversation].is_private
                && CONV_STORAGE.private){
                    CONV_STORAGE.private.sendPrivateStreamIds();
                    CONV_STORAGE.sendPrivacyThumbnail(CONV_STORAGE.myConversation);
                }
        } catch (error) { console.error("[Kino Error] [announcement]", error); }
        if(s.muteOnStopAnnouncing){
            muteMic();
        }
        s.sendStopAnnouncementMsg();
        $("#announcement-zone").css( 'display' ,'none');
        if(s.quickAnnounce){
            setTimeout(() => {
                Video.localVideo.viewContainer.removeClass('video-hover');
                Video.localVideo.viewContainer.find('.announce-icon svg').removeClass('announcing')
            }, 50);
        }
        unlockControlFromClosing()
    };


    sendStartAnnouncementMsg(){
        var s=this;
        try {
            if(CONV_STORAGE.myConversation
                && CONV_STORAGE.conversations[CONV_STORAGE.myConversation]
                && CONV_STORAGE.conversations[CONV_STORAGE.myConversation].is_private
                && CONV_STORAGE.private){
                    CONV_STORAGE.private.stopSendingStreamsPrivate();
                    CONV_STORAGE.sendPrivacyThumbnail(CONV_STORAGE.myConversation,true);
                }
        } catch (error) { console.error("[Kino Error] [announcement]", error); }
        socket.sendBroadcastMessage({
            eventName: "announcementStart",
            data: {
                participant: room.myUserId(),
                room_id: room.getName()
            },
            room_id:room.getName()
        });
    };

    isAnnouncingMsg(user) {
        this.announcementStartEvent({
            eventName: "announcementStart",
            data: {
                participant: user.getId(),
                room_id: room.getName()
            },
            room_id:room.getName()
        })
    }

    sendStopAnnouncementMsg(){
        var s=this;
        socket.sendBroadcastMessage({
            eventName: "announcementStop",
            data: {
                participant: room.myUserId(),
                room_id: room.getName()
            },
            room_id:room.getName()
        });
    };

    announcementStartEvent(request){
        var s=this;
        let data=request.data;
        if(muteParticipants.canIMuteParticipant(data.participant)){
            Video.videos[data.participant].hideMuteButton();
        }
        if(!s.announcers.includes(data.participant)){s.announcers.push(data.participant);}
        if(s.announcers.length==1){
            if(!volumeManager.masterMuted){
                s.lowEveryoneVolume();
            }else{
                s.lowEveryoneVolume(0);
            }
        }
        try {
            s.showNotification(Video.videos[data.participant].displayName,data.participant);
            s.announcersVolume[data.participant]=Video.videos[data.participant].volume;
            if(Video.sideParticipants[data.participant]!==undefined){
                Video.moveSideVideoToTop(data.participant);
            }
            // if(Video.masterMuted){
            volumeManager.changeParticipantVolume(data.participant,1,true);
            // }
            Video.videos[data.participant].viewContainer.addClass("speaking");
            // console.log(Video.videos[data.participant].video)
            const videoTrack = getRemoteParticipantMainVideoTrack(data.participant);
            if(!videoTrack || videoTrack.muted){
                Video.videos[data.participant].noCameraLayer.removeClass('d-none');
                Video.videos[data.participant].viewContainer.addClass("no-camera");
            }

        } catch (error) {
            console.log(error);
        }
        console.log("Announcement start event",s.announcers);
    };

    announcementStopEvent(request){
        var s=this;
        let data=request.data;
        s.announcers=s.announcers.filter(id=>id!==data.participant);
        if(muteParticipants.canIMuteParticipant(data.participant)){
            Video.videos[data.participant].showMuteButton();
        }
        // let mySpace=CONV_STORAGE.myConversation;
        // let announcerSpace=CONV_STORAGE.isOnConversation(data.participant);
        console.log(`Announcer stop event,muteVolumeOverwite ${volumeManager.muteVolumeOverwrite}`,)
        let announcerVolume = s.announcers.length > 0 ? 0.05 : s.announcersVolume[data.participant];
        if(Video.focused[data.participant] || kinoParticipants.isInMySpace(data.participant)){
            announcerVolume=s.announcersVolume[data.participant];
        }else if(volumeManager.masterMuted && kinoParticipants.inSameSpaceWith(data.participant)){
            Video.lastParticipantVolume[data.participant]=1;
            announcerVolume=1;
        }else if(volumeManager.masterMuted && volumeManager.muteVolumeOverwrite && CONV_STORAGE.myConversation){
            Video.lastParticipantVolume[data.participant]=0.05;
            announcerVolume=0;
        }else if(volumeManager.masterMuted && volumeManager.muteVolumeOverwrite && !CONV_STORAGE.myConversation){
            if(CONV_STORAGE.isOnConversation(data.participant)){
                Video.lastParticipantVolume[data.participant]=0.05;
                announcerVolume=0;
            }
        }
        volumeManager.changeParticipantVolume(data.participant,announcerVolume);
        Video.videos[data.participant].viewContainer.removeClass("speaking");
        // CONV_STORAGE.updateThumbnailImage(data.participant);
        $(`.announcement-notification-${data.participant}`).remove();
        if(s.announcers.length > 0){
            s.originalVolumes[data.participant]=s.announcersVolume[data.participant];
            delete s.announcersVolume[data.participant];
        }else{
            delete s.announcersVolume[data.participant];
            s.resetEveryoneVolume();
        }

        console.log("Announcement stop event",s.announcers);
    };

    lowEveryoneVolume(volume=0.05){
        var s=this;
        $.each(Video.videos,function(id,video){
            if(!s.announcers.includes(id)){
                try {
                    s.originalVolumes[id]=Video.videos[id].volume;
                    let inSpaceVolume=volume;
                    if(s.originalVolumes[id] > 0 && volume==0){
                        inSpaceVolume=0.05;
                    }
                    volumeManager.changeParticipantVolume(id,inSpaceVolume,true);
                } catch (error) {
                    console.warn("Unable to low participant volume",error);
                }

            }
        });
    };

    updateOriginalVolume(id,volume,allowVolumeLock=false){
        let existingUsers=this.announcers.filter(p=>Video.videos[p]!==undefined);
        if(existingUsers.length){
            console.log("Is announcer "+id,existingUsers.includes(id));
            if(existingUsers.includes(id)){
                if(volume==0){return true}
                this.announcersVolume[id]=volume;
                return true;
            }else{
                if(volume==0){return false}
                this.originalVolumes[id]=volume;
                return allowVolumeLock;
            }
        }
        return false;
    };

    resetEveryoneVolume(){
        var s=this;
        //app.videos[participant].audios.slider.val(volume)
        $.each(Video.videos,function(id,video){
            if(!s.announcers.includes(id) && s.originalVolumes[id]!==undefined){
                try {
                    let volume=s.originalVolumes[id];
                //    let mySpace=CONV_STORAGE.myConversation;
                //    let pSpace=CONV_STORAGE.isOnConversation(id);
                    if(volumeManager.masterMuted  && volumeManager.muteVolumeOverwrite==false && !kinoParticipants.inSameSpaceWith(id)){
                        volumeManager.lastParticipantVolume[id]=s.originalVolumes[id];
                        volume=0;
                    }else if(volumeManager.masterMuted && !Video.focused[id] && volumeManager.muteVolumeOverwrite && CONV_STORAGE.myConversation && !kinoParticipants.isInMySpace(id)){
                        volumeManager.lastParticipantVolume[id]=0.05;
                        volume=0;
                    }else if(kinoParticipants.inSameSpaceWith(id)){
                        volumeManager.lastParticipantVolume[id] = 1;
                        volume = 1;
                    }else if(volumeManager.masterMuted && volumeManager.muteVolumeOverwrite && CONV_STORAGE.isOnConversation(id)){
                        volumeManager.lastParticipantVolume[id]=0.05;
                        volume=0;
                    }
                    console.log("Original volume from announcer for "+id+" is",s.originalVolumes[id])
                    console.log('Same space with  '+id+' : '+kinoParticipants.inSameSpaceWith(id));
                    volumeManager.changeParticipantVolume(id,volume,true);
                    delete s.originalVolumes[id];
                } catch (error) {
                    console.warn("Unable to reset participant volume",error);
                }
            }
        });

    };
    showNotification(user_name,participant_id){
        var sf=this;
        Video.showNotification(sf.htmlIcon,`${user_name} is making an announcement`,'announcement',participant_id);
    };

    // appendAnnouncerOnLocalTile(){
    //     let sf = this;

    //     sf.announcerOnLocalTile = $('<div/>',{
    //         class: 'toolbar-icon announce-icon',
    //         'data-toggle': 'tooltip',
    //         'data-placement': 'top',
    //         title: `Announcer`,
    //         style: 'margin-bottom:3px',
    //         html: sf.announceIconFilled,
    //     }).on('click', function(){
    //         sf.showToolBoxComponents();
    //     }).on('mousedown', function(e){
    //         if(e.which == 1){
    //             sf.pressStart(sf)
    //             sf.showToolBoxComponents();
    //         }
    //         sf.pressHoldDuration = 40;
    //         sf.pressReadyDuration = 70;
    //         sf.quickAnnounce = true;
    //     })
    //     .on("mouseup", sf.pressStop.bind(this,sf))
    //     .on("touchstart", sf.pressStart.bind(this,sf))
    //     .on("touchend", sf.pressStop.bind(this,sf));

    //     Video.localVideo.announceShortcut.append(sf.announcerOnLocalTile);
    // }

    removeAnnouncerFromLocalVideo(){
        let sf = this;
        if(sf.announcerOnLocalTile){
            sf.announcerOnLocalTile.remove();
        }
    }

};
